import * as types from '../../actiontypes';
import {promiseAreas} from './../../../util/uiconstants';

export const getQuickLinks = (url) => {
	return {
		type: types.GET_QUICKLINKS_BY_ENGAGEMENTID,
		meta: {
			api: {
				url,
				method: 'GET',
				trackWithArea: promiseAreas.QUICK_LINK_AREA
			}
		}
	};
};
